import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { colors } from "../colors_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";

const render = async () => {
  const html = `
    <div class="popUpHead">Change Password</div>
    
    <form id="changePasswordform">
      <div class="center">
        <label for="oldPasswordInput">Current Password:</label>
        <input class="bottom7" type="password" id="oldPasswordInput" autocomplete="current-password">
        <div class="inputMessages center" id="oldPasswordMessage"></div>
      </div>
      <br>
      <div class="center">
        <label for="newPassword1Input">New Password:</label>
        <input class="bottom7" type="password" id="newPassword1Input" autocomplete="new-password">
        <div class="inputMessages center" id="newPassword1Message"></div>
      </div>
      <br>
      <div class="center">
        <label for="newPassword2Input">Re-Enter New Password:</label>
        <input class="bottom7" type="password" id="newPassword2Input" autocomplete="new-password">
        <div class="inputMessages center" id="newPassword2Message"></div>
      </div>
      <br>
      <div class="center">
        <button 
          type="submit" 
          id="changePasswordSubmit" 
          class="submitButton bottom7 button workADayButtons">
          Submit
        </button>
        <div class="inputMessages center" id="changePasswordSubmitMessage"></div>
      </div>
    </form>
  `;

  dasModal.render(html);
  // document
  //   .getElementById("changePasswordSubmit")
  //   .addEventListener("click", handleChangePasswordSubmit);

  const oldPasswordInput = document.getElementById("oldPasswordInput");
  // oldPasswordInput.addEventListener("keyup", handlePasswordKeyUp);
  oldPasswordInput.style.backgroundColor = colors.getGameColor("lighterAccent");
  oldPasswordInput.focus();

  const newPassword1Input = document.getElementById("newPassword1Input");
  // newPassword1Input.addEventListener("keyup", handlePasswordKeyUp);
  newPassword1Input.style.backgroundColor =
    colors.getGameColor("lighterAccent");

  const newPassword2Input = document.getElementById("newPassword2Input");
  // newPassword2Input.addEventListener("keyup", handlePasswordKeyUp);
  newPassword2Input.style.backgroundColor =
    colors.getGameColor("lighterAccent");
};

const handlePasswordKeyUp = (event) => {
  const inputElement = event.target;
  const password = inputElement.value;
  let messageElement;
  switch (inputElement.id) {
    case "oldPasswordInput":
      messageElement = document.getElementById("oldPasswordMessage");
      break;
    case "newPassword1Input":
      messageElement = document.getElementById("newPassword1Message");
      break;
    case "newPassword2Input":
      messageElement = document.getElementById("newPassword2Message");
      break;
  }

  const result = identityService.isPasswordValid(password);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleChangePasswordSubmit = async (event) => {
  const oldPassword = document.getElementById("oldPasswordInput").value;
  const newPassword1 = document.getElementById("newPassword1Input").value;
  const newPassword2 = document.getElementById("newPassword2Input").value;
  const messageElement = document.getElementById("changePasswordSubmitMessage");
  const changePasswordSubmit = document.getElementById("changePasswordSubmit");

  if (newPassword1 != newPassword2) {
    messageElement.innerText =
      "The new password must be the same in both fields";
    return;
  }

  if (oldPassword === newPassword2) {
    messageElement.innerText =
      "The new password must be different from the old one.";
    return;
  }
  const resultOld = identityService.isPasswordValid(oldPassword);
  const resultNew1 = identityService.isPasswordValid(newPassword1);
  const resultNew2 = identityService.isPasswordValid(newPassword2);
  if (
    resultOld.status != 200 ||
    resultNew1.status != 200 ||
    resultNew2.status != 200
  ) {
    messageElement.innerText = "Please correct the errors above";
    return;
  }
  document.body.style.cursor = "wait";
  messageElement.innerText = "Submitting...";
  changePasswordSubmit.disabled = true;
  changePasswordSubmit.style.cursor = "wait";
  const result = await identityService.passwordChange({
    oldPassword,
    newPassword: newPassword1,
  });
  document.body.style.cursor = "default";
  changePasswordSubmit.style.cursor = "default";
  messageElement.innerText = "";
  changePasswordSubmit.disabled = false;
  if (result.status != 200) {
    console.log(result);
    messageElement.innerText = result.error;
    return;
  }
  if (result.status === 200) {
    dasModal.close();
    profile.render("small");
    dasModal.render(`<div class="max">The password has been updated.</div>`);
    return;
  }
};

eventHub.registerEvent(
  "click",
  "changePasswordSubmit",
  handleChangePasswordSubmit,
);
eventHub.registerEvent("keyup", "oldPasswordInput", handlePasswordKeyUp);
eventHub.registerEvent("keyup", "newPassword1Input", handlePasswordKeyUp);
eventHub.registerEvent("keyup", "newPassword2Input", handlePasswordKeyUp);

export const changePasswordPop = {
  render,
};
